export default "__VITE_ASSET__Y0xxh7ck__"